import React, { useEffect, useState } from "react";
import Header from "../../../common/header/header";
import Nav from "../nav";
import { Button, TextInput } from "@mantine/core";
import { useLocation } from "react-router-dom";

const Fair_Market_Pe = () => {
  const [growthAssumption, setGrowthAssumption] = useState("");
  const [riskFreeRate, setRiskFreeRate] = useState("");
  const [fairMarketPE, setFairMarketPE] = useState(null);
  const [results, setResults] = useState(null);
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const CalculatorFairMarketPE = () => {
    const G = parseFloat(growthAssumption);
    const Risk_Free = parseFloat(riskFreeRate);

    const Rp = 0.06;
    const g = G / 100;
    const Rf = Risk_Free / 100;

    const PE = (1 + g) / (Rf + Rp - g);

    setFairMarketPE(PE.toFixed(2));

    setResults({
      fairPE: PE.toFixed(2),
    });
  };

  return (
    <>
      <Header />
      <div className="row omcboxed" style={styles.navWidth}>
        <Nav nopadding={true} />
      </div>
      <div className="fair-market">
        <div className="container container_box">
        <div className="row">
        <div className="col-md-6">
          <div className="spi-box-field fair-market-boxed">
            <div className="fair-search-field">
                <div className="spi-calculator-field">
                  <TextInput
                    label="Growth Assumption (%)*"
                    placeholder="Enter Growth Amount"
                    type="number"
                    value={growthAssumption}
                    onChange={(event) =>
                      setGrowthAssumption(event.currentTarget.value)
                    }
                  />
                </div>
                <div className="spi-calculator-field">
                  <TextInput
                    label="Risk free rate (%)*"
                    placeholder="Risk Free Rate"
                    type="number"
                    value={riskFreeRate}
                    onChange={(event) =>
                      setRiskFreeRate(event.currentTarget.value)
                    }
                  />
                </div>
                </div>
                <Button
                  className="wealth-button mt-auto"
                  onClick={CalculatorFairMarketPE}
                >
                  Plan My Wealth
                </Button>
              </div>
              </div>
              {results && (
                <div className="col-md-5">
                  <div className="result-data-show">
                    <div className="result-content fair-market-content">
                      <h1>RESULT</h1>
                    </div>
                    <div className="price-boxes">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>Calculated Fair PE</th>
                            <th className="text-right">{results.fairPE}</th>
                          </tr>
                        </thead>
                      </table>
                    </div>
                  </div>
                </div>
              )}
          </div>
        </div>
      </div>
    </>
  );
};

const styles = {
  navWidth: {
    width: "100%",
    fontSize: "14px",
    margin: "auto",
    marginBottom: "10px",
    justifyContent: "space-between",
  },
};

export default Fair_Market_Pe;
